/* Nova AI · chat con risposta in streaming (token in tempo reale)
   Backend: Supabase Edge Function "nova-ai" (recupero prodotti + OpenAI SSE). */
(function () {
  var root = document.getElementById('NovaAssistant');
  if (!root) return;

  var ENDPOINT = root.dataset.endpoint;
  var KEY = root.dataset.key;
  var launcher = root.querySelector('.nova-as__launcher');
  var panel = root.querySelector('.nova-as__panel');
  var closeBtn = root.querySelector('.nova-as__close');
  var form = root.querySelector('#NovaAsForm');
  var input = root.querySelector('#NovaAsInput');
  var sendBtn = root.querySelector('.nova-as__send');
  var msgs = root.querySelector('#NovaAsMessages');

  var history = [];
  var busy = false;
  var MIN_THINK = 1400; // ~1,4s di "sta pensando" prima di mostrare il testo

  // Su mobile la chat è a schermo intero: nascondiamo i bottoni flottanti di
  // terze parti (WhatsApp, "Gira la ruota", ecc.) così non si sovrappongono.
  // Approccio generico: nascondiamo gli elementi fixed piccoli in basso, senza
  // dover conoscere il selettore esatto di ogni app. Ripristinati alla chiusura.
  var hiddenWidgets = [];
  function hideFloatingWidgets(hide) {
    if (hide) {
      hiddenWidgets = [];
      var kids = document.body.children;
      for (var i = 0; i < kids.length; i++) {
        var el = kids[i];
        if (el === root || el.id === 'NovaAssistant') continue;
        var tag = el.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' || tag === 'NOSCRIPT') continue;
        var st = window.getComputedStyle(el);
        if (st.position !== 'fixed' || st.display === 'none' || st.visibility === 'hidden') continue;
        var r = el.getBoundingClientRect();
        if (r.width === 0 || r.height === 0) continue;
        var inLowerArea = r.top > window.innerHeight * 0.45;
        var smallish = r.width < 420 && r.height < 420;
        if (inLowerArea && smallish) {
          hiddenWidgets.push({ el: el, prev: el.style.display });
          el.style.display = 'none';
        }
      }
    } else {
      hiddenWidgets.forEach(function (o) { o.el.style.display = o.prev; });
      hiddenWidgets = [];
    }
  }

  function openPanel() {
    var greet = root.querySelector('.nova-as__greeting');
    if (greet) greet.remove();
    panel.hidden = false;
    launcher.classList.add('is-hidden');
    launcher.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('nova-open');
    if (window.matchMedia('(max-width: 600px)').matches) hideFloatingWidgets(true);
    setTimeout(function () { input.focus(); }, 80);
  }
  function closePanel() {
    panel.hidden = true;
    launcher.classList.remove('is-hidden');
    launcher.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('nova-open');
    hideFloatingWidgets(false);
  }
  launcher.addEventListener('click', openPanel);
  closeBtn.addEventListener('click', closePanel);

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }
  function formatText(s) {
    var html = escapeHtml(s);
    html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, '$1<em>$2</em>');
    html = html.replace(/__([^_]+)__/g, '<strong>$1</strong>');
    return html.replace(/\n/g, '<br>');
  }
  // Formattazione durante lo streaming: chiude il grassetto in corso e toglie
  // gli asterischi residui, così non si vedono mai i ** mentre scrive.
  function formatStreaming(s) {
    var t = s;
    if (((t.match(/\*\*/g) || []).length) % 2 === 1) t += '**';
    return formatText(t).replace(/\*/g, '');
  }
  function fmtPrice(p) {
    if (p == null) return '';
    return '€ ' + Number(p).toFixed(2).replace('.', ',');
  }

  function buildCard(p) {
    var card = document.createElement('a');
    card.className = 'nova-as__card';
    card.href = p.url;
    card.target = '_blank';
    card.rel = 'noopener';
    card.innerHTML =
      '<span class="nova-as__card-img" aria-hidden="true"></span>' +
      '<span class="nova-as__card-body">' +
      '<span class="nova-as__card-name">' + escapeHtml(p.title) + '</span>' +
      '<span class="nova-as__card-price">' + fmtPrice(p.price) + '</span>' +
      '</span>' +
      '<span class="nova-as__card-cta" aria-hidden="true">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>' +
      '</span>';
    try {
      var path = new URL(p.url, window.location.origin).pathname;
      fetch(window.location.origin + path + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (data && data.featured_image) {
            var img = data.featured_image;
            if (img.indexOf('//') === 0) img = 'https:' + img;
            card.querySelector('.nova-as__card-img').style.backgroundImage = 'url("' + img + '")';
          }
        })
        .catch(function () {});
    } catch (_e) {}
    return card;
  }

  function createAiWrap() {
    var wrap = document.createElement('div');
    wrap.className = 'nova-as__msg nova-as__msg--ai';
    var bubble = document.createElement('div');
    bubble.className = 'nova-as__bubble';
    wrap.appendChild(bubble);
    msgs.appendChild(wrap);
    return { wrap: wrap, bubble: bubble };
  }
  function addUserMessage(text) {
    var wrap = document.createElement('div');
    wrap.className = 'nova-as__msg nova-as__msg--user';
    var bubble = document.createElement('div');
    bubble.className = 'nova-as__bubble';
    bubble.textContent = text;
    wrap.appendChild(bubble);
    msgs.appendChild(wrap);
    msgs.scrollTop = msgs.scrollHeight;
  }

  // Render finale: pulisce gli URL (niente link inventati), formatta, aggiunge card
  function renderAiContent(wrap, bubble, text, products) {
    var referenced = [];
    var lower = text.toLowerCase();
    (products || []).forEach(function (p) {
      if (referenced.length >= 3) return;
      var byUrl = p.url && text.indexOf(p.url) !== -1;
      var key = (p.title || '').toLowerCase().slice(0, 22);
      var byTitle = key.length > 6 && lower.indexOf(key) !== -1;
      if (byUrl || byTitle) referenced.push(p);
    });
    var clean = text
      .replace(/\(?\s*(?:link|url)\s*:?\s*\)?\s*https?:\/\/[^\s)]+\)?/gi, '')
      .replace(/https?:\/\/[^\s)]+/g, '')
      .replace(/\(\s*\)/g, '')
      .replace(/[ \t]{2,}/g, ' ')
      .replace(/[ \t]*\n/g, '\n')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
    bubble.innerHTML = formatText(clean);
    var oldCards = wrap.querySelector('.nova-as__cards');
    if (oldCards) oldCards.remove();
    if (referenced.length) {
      var cards = document.createElement('div');
      cards.className = 'nova-as__cards';
      referenced.forEach(function (p) { cards.appendChild(buildCard(p)); });
      wrap.appendChild(cards);
    }
    msgs.scrollTop = msgs.scrollHeight;
  }

  function setThinking(on) {
    var existing = msgs.querySelector('.nova-as__thinking-wrap');
    if (on) {
      if (existing) return;
      var w = document.createElement('div');
      w.className = 'nova-as__msg nova-as__msg--ai nova-as__thinking-wrap';
      w.innerHTML = '<div class="nova-as__thinking"><span class="nova-as__thinking-text">Nova sta pensando</span></div>';
      msgs.appendChild(w);
      msgs.scrollTop = msgs.scrollHeight;
    } else if (existing) {
      existing.remove();
    }
  }

  function endTurn() {
    busy = false;
    sendBtn.disabled = false;
    input.focus();
  }

  // I token arrivano dal server, ma il testo appare a velocità controllata
  // (loop su requestAnimationFrame) con cursore luminoso: effetto "digitazione"
  // professionale, indipendente dalla velocità della rete.
  function consumeStream(body, products) {
    var reader = body.getReader();
    var decoder = new TextDecoder();
    var buffer = '', full = '', target = '', displayed = 0;
    var wrap = null, bubble = null, started = false, streamDone = false;
    var start = Date.now(), rafId = null, lastT = 0, acc = 0;

    function renderPartial() {
      bubble.innerHTML = formatStreaming(target.slice(0, displayed)) +
        '<span class="nova-as__caret" aria-hidden="true"></span>';
      msgs.scrollTop = msgs.scrollHeight;
    }
    function loop(t) {
      if (!lastT) lastT = t;
      var dt = Math.min(0.05, (t - lastT) / 1000);
      lastT = t;
      if (displayed < target.length) {
        var speed = Math.max(32, target.length / 4); // caratteri al secondo (rallentato)
        acc += speed * dt;
        var add = Math.floor(acc);
        if (add > 0) {
          acc -= add;
          displayed = Math.min(target.length, displayed + add);
          renderPartial();
        }
      }
      if (streamDone && displayed >= target.length) { finalizeNow(); return; }
      rafId = requestAnimationFrame(loop);
    }
    function ensureStarted() {
      if (started) return;
      if (Date.now() - start < MIN_THINK) return;
      if (!target.length && !streamDone) return;
      started = true;
      setThinking(false);
      var el = createAiWrap();
      wrap = el.wrap;
      bubble = el.bubble;
      bubble.classList.add('nova-as__bubble--streaming');
      lastT = 0;
      rafId = requestAnimationFrame(loop);
    }
    function finalizeNow() {
      if (rafId) cancelAnimationFrame(rafId);
      bubble.classList.remove('nova-as__bubble--streaming');
      renderAiContent(wrap, bubble, full || 'Scusa, non ho una risposta al momento. Riprova o scrivici su WhatsApp.', products);
      if (full) history.push({ role: 'assistant', content: full });
      endTurn();
    }

    // Garantisce l'avvio dopo il "sta pensando" anche se la risposta è già pronta
    setTimeout(ensureStarted, MIN_THINK + 40);

    function pump() {
      return reader.read().then(function (res) {
        if (res.done) { streamDone = true; ensureStarted(); return; }
        buffer += decoder.decode(res.value, { stream: true });
        var parts = buffer.split('\n');
        buffer = parts.pop();
        parts.forEach(function (line) {
          line = line.trim();
          if (line.indexOf('data:') !== 0) return;
          var p = line.slice(5).trim();
          if (!p || p === '[DONE]') return;
          try {
            var obj = JSON.parse(p);
            var delta = obj.choices && obj.choices[0] && obj.choices[0].delta && obj.choices[0].delta.content;
            if (delta) { full += delta; target += delta; ensureStarted(); }
          } catch (e) {}
        });
        return pump();
      });
    }
    return pump();
  }

  // --- Allega foto: bottone fotocamera iniettato nel form (il backend riconosce il prodotto) ---
  var pendingImage = null;
  var photoBtn = null;
  var fileInput = null;
  if (form && input) {
    fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.style.display = 'none';
    photoBtn = document.createElement('button');
    photoBtn.type = 'button';
    photoBtn.className = 'nova-as__photo';
    photoBtn.setAttribute('aria-label', 'Allega una foto del prodotto');
    photoBtn.title = 'Allega una foto del prodotto';
    photoBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>';
    form.insertBefore(photoBtn, input);
    form.appendChild(fileInput);
    var photoStyle = document.createElement('style');
    photoStyle.textContent = '.nova-as__photo{flex:0 0 auto;display:grid;place-items:center;align-self:flex-end;width:40px;height:40px;border:0;border-radius:10px;background:transparent;color:#6b7280;cursor:pointer;transition:background .15s ease,color .15s ease}.nova-as__photo:hover{background:rgba(0,0,0,.06)}.nova-as__photo.has-image{color:#e8590c;background:rgba(232,89,12,.1)}';
    document.head.appendChild(photoStyle);
    photoBtn.addEventListener('click', function () { fileInput.click(); });
    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      if (!f) return;
      var img = new Image();
      var url = URL.createObjectURL(f);
      img.onload = function () {
        var max = 768;
        var scale = Math.min(1, max / Math.max(img.width, img.height));
        var c = document.createElement('canvas');
        c.width = Math.round(img.width * scale);
        c.height = Math.round(img.height * scale);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        pendingImage = c.toDataURL('image/jpeg', 0.8);
        photoBtn.classList.add('has-image');
        URL.revokeObjectURL(url);
        input.placeholder = 'Foto pronta: scrivi la domanda e invia';
        input.focus();
      };
      img.src = url;
      fileInput.value = '';
    });
  }

  function sendMessage(text) {
    text = (text || '').trim();
    if ((!text && !pendingImage) || busy) return;
    var shown = text || 'Ho inviato una foto del prodotto';
    addUserMessage(pendingImage ? shown + ' 📷' : shown);
    var content = pendingImage
      ? [{ type: 'text', text: shown }, { type: 'image_url', image_url: { url: pendingImage } }]
      : shown;
    history.push({ role: 'user', content: content });
    var sentWithImage = !!pendingImage;
    pendingImage = null;
    if (photoBtn) photoBtn.classList.remove('has-image');
    input.value = '';
    input.placeholder = 'Scrivi un messaggio…';
    autosize();
    busy = true;
    sendBtn.disabled = true;
    setThinking(true);

    var payloadMessages = history.slice(-10);
    // L'immagine serve solo per questo turno: nella cronologia resta il testo,
    // così i messaggi successivi non ricaricano la foto ogni volta.
    if (sentWithImage) history[history.length - 1] = { role: 'user', content: shown + ' (foto inviata)' };

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', apikey: KEY, Authorization: 'Bearer ' + KEY },
      body: JSON.stringify({ messages: payloadMessages }),
    })
      .then(function (resp) {
        var ct = resp.headers.get('content-type') || '';
        if (!resp.ok || ct.indexOf('text/event-stream') === -1 || !resp.body) {
          setThinking(false);
          var el = createAiWrap();
          renderAiContent(el.wrap, el.bubble, 'Spiacente, al momento non riesco a rispondere. Riprova tra poco o scrivici su WhatsApp.', []);
          endTurn();
          return;
        }
        var products = [];
        try {
          var h = resp.headers.get('X-Nova-Products');
          if (h) products = JSON.parse(decodeURIComponent(h));
        } catch (e) {}
        return consumeStream(resp.body, products);
      })
      .catch(function () {
        setThinking(false);
        var el = createAiWrap();
        renderAiContent(el.wrap, el.bubble, 'Connessione non riuscita. Controlla la rete e riprova.', []);
        endTurn();
      });
  }

  function autosize() {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 120) + 'px';
  }
  input.addEventListener('input', autosize);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); form.requestSubmit(); }
  });
  form.addEventListener('submit', function (e) { e.preventDefault(); sendMessage(input.value); });

  // Apertura da fuori (bottone "Chiedi maggiori info" nella pagina prodotto)
  function ask(title, url) {
    openPanel();
    var q = 'Vorrei maggiori informazioni su «' + title + '»';
    if (url) q += ' (' + url + ')';
    q += '. Caratteristiche principali, prezzo e se fa al caso mio?';
    setTimeout(function () { sendMessage(q); }, 120);
  }
  window.NovaAsk = ask;
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.nova-ask-trigger');
    if (!trigger) return;
    e.preventDefault();
    ask(trigger.getAttribute('data-product-title') || 'questo prodotto', trigger.getAttribute('data-product-url') || '');
  });

  // Richiamo in home: fumetto invitante vicino al launcher (una volta sola)
  if (root.dataset.home === 'true') {
    setTimeout(function () {
      if (!panel.hidden) return;
      try { if (localStorage.getItem('nova_greeted')) return; } catch (e) {}
      var g = document.createElement('div');
      g.className = 'nova-as__greeting';
      g.innerHTML =
        '<button class="nova-as__greeting-close" aria-label="Chiudi" type="button">×</button>' +
        '<strong>Ciao, sono Nova 👋</strong>' +
        '<span>Hai domande sui prodotti o sugli ordini? Chiedimi info o un consiglio in tempo reale.</span>';
      root.appendChild(g);
      try { localStorage.setItem('nova_greeted', '1'); } catch (e) {}
      g.addEventListener('click', function (e) {
        if (e.target.closest('.nova-as__greeting-close')) { g.remove(); return; }
        g.remove();
        openPanel();
      });
    }, 3500);
  }
})();
